export const SPECIFIC_HELP_KEY = {
    STID_ID_MOBILE : "STID_ID_MOBILE",
    HID_MOBILE_ACCESS : "HID_MOBILE_ACCESS",
    MQTT_ACCOUNT : "MQTT_ACCOUNT",
    ACCESS_GROUP_REPORT : "ACCESS_GROUP_REPORT",
    ABSENTEEISM_REPORT : "ABSENTEEISM_REPORT",
    TRANSACTION_REPORT : "TRANSACTION_REPORT",
    AREA_REPORT: "AREA_REPORT",
    CARD_EXPIRY_REPORT: "CARD_EXPIRY_REPORT",
    ENROLMENT_REPORT: "ENROLMENT_REPORT",
    FIRST_IN_LAST_OUT_REPORT: "FIRST_IN_LAST_OUT_REPORT",
    HARDWARE_INSTALLATION_REPORT: "HARDWARE_INSTALLATION_REPORT",
    HOLIDAY_REPORT: "HOLIDAY_REPORT",
    HOURS_WORKED_REPORT: "HOURS_WORKED_REPORT",
    GENERAL_MUSTERING_REPORT: "GENERAL_MUSTERING_REPORT",
    ZONE_OCCUPANCY_REPORT: "ZONE_OCCUPANCY_REPORT",
    STILL_ON_SITE_REPORT: "STILL_ON_SITE_REPORT",
    ALARM_TRANSACTIONS_REPORT: "ALARM_TRANSACTIONS_REPORT",
    DENIED_TRANSACTIONS_REPORT: "DENIED_TRANSACTIONS_REPORT",
    STATUS_TRANSACTIONS_REPORT: "STATUS_TRANSACTIONS_REPORT",
    TIME_AND_ATTENDANCE_REPORT: "TIME_AND_ATTENDANCE_REPORT",
    IDEMIA_PRESET: "IDEMIA_PRESET",
    CONTROL_ID_PRESET: "CONTROL_ID_PRESET",
    LOCK_PRESET: "LOCK_PRESET",
    LOCKER_PRESET: "LOCKER_PRESET",
    GUARD_ROLE: "GUARD_ROLE",
    SITE_ADMIN_ROLE: "SITE_ADMIN_ROLE",
    INSTALLER_ROLE: "INSTALLER_ROLE",
    REPORTER_ROLE: "REPORTER_ROLE",
    RECEPTION_ROLE: "RECEPTION_ROLE",
    SYSTEM_OWNER_ROLE: "SYSTEM_OWNER_ROLE",
    SOFTWARE_SECURITY_POLICY: "SOFTWARE_SECURITY_POLICY",
    CERTIFICATE_SECURITY_POLICY: "CERTIFICATE_SECURITY_POLICY",
    VINGCARD_TRANSACTION_REPORT: "VINGCARD_TRANSACTION_REPORT",
    AUDIT_REPORT: "AUDIT_REPORT",
    CARDS_NOT_USED_REPORT: "CARDS_NOT_USED_REPORT",
    DOOR_ACCESS: "DOOR_ACCESS",
    ENTRY_TEST_OUTCOMES_REPORT: "ENTRY_TEST_OUTCOMES_REPORT",
    GENERAL_ACCESS: "GENERAL_ACCESS",
    PERSON_ACCESS: "PERSON_ACCESS",
    OPERATIONAL_COMPLIANCE: "OPERATIONAL_COMPLIANCE",
    TRANSACTIONAL_REPORTS: "TRANSACTIONAL_REPORTS",
    TIME_AND_ATTENDANCE_REPORTS: "TIME_AND_ATTENDANCE_REPORTS",
    ACCESS_CONTROL_REPORTS: "ACCESS_CONTROL_REPORTS",
    SYSTEM_SETUP_REPORTS: "SYSTEM_SETUP_REPORTS",
    EMERGENCY_AND_SAFETY_REPORTS: "EMERGENCY_AND_SAFETY_REPORTS",
    COMPLIANCE_REPORTS: "COMPLIANCE_REPORTS",
    ALL_REPORTS: "ALL_REPORTS",
}
